import React, { useState, useEffect } from "react";
import styles from "./MisProyectos.module.scss";
import { connect } from "react-redux";
import {
    getProjects,
    closeMainModal,
} from "../../../../store/actions/index";
import { motion } from "framer-motion";
import { ReactComponent as AddProyect } from "../../../../assets/svg/crearPP.svg";
import { ReactComponent as Search } from "../../../../assets/svg/misProyectosLittle.svg";
import { ReactComponent as ArrowDownIcon } from "../../../../assets/svg/arrowDownIcon.svg";
import EmptyState from "../../../UI/EmptyState/EmptyState";
import { useActionGuard } from "../../../../hooks/useActionGuard.ts";
import ProjectCardWithLogic from "./ProjectCardWithLogic.tsx";
import { useNavigate } from "react-router-dom";
import RegisteredUserProfileLoader from "../../../RegisteredUsers/RegisteredUsersSkeleton/RegisteredUserProfileLoader";


const MisProyectos = ({
    proyectos,
    proyectosLoading,
    perfilAjeno,
    closeMainModal,
    getProjects,
    myPerson,
    userData,
    setInfoReady,
    currentTab,
    ...props
}) => {
    const [visibleItems, setVisibleItems] = useState(8);
    const navigate = useNavigate();

    useEffect(() => {
        getProjects(myPerson ? userData.id : perfilAjeno);
    }, [userData.id, perfilAjeno]);

    useEffect(() => {
        if (!proyectosLoading && proyectos !== undefined) {
            setInfoReady(true);
        }
    }, [proyectosLoading, proyectos, setInfoReady]);

    const { guard } = useActionGuard()

    const proyectosToMap = proyectos?.filter((proyecto) => proyecto.type === "PRIVATE");

    const handleNewOpenProject = () => {
        navigate("/obrasprivadas/crear");
        closeMainModal();
    };

    const handleToggleVisibility = () => {
        if (visibleItems === 8) {
            setVisibleItems(proyectosToMap.length);
        } else {
            setVisibleItems(8);
        }
    };

    return (
        <motion.section
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className={styles.container}
        >
            {proyectosLoading ? (
                <div className={styles.loadingContainer}>
                    <RegisteredUserProfileLoader />
                </div>
            ) : (
                proyectos && proyectosToMap.length > 0 ? (
                    <>
                        <div className={styles.container_body}>
                            {proyectosToMap.slice(0, visibleItems).map((proyecto) => (
                                <ProjectCardWithLogic
                                    key={proyecto.id}
                                    project={proyecto}
                                    myPerson={myPerson}
                                    userData={userData}
                                    currentTab={currentTab}
                                />
                            ))}
                        </div>
                        {proyectosToMap.length > 0 && (
                            proyectosToMap.length > visibleItems ? (
                                <div className={styles.PerfilMain_content_seeMore} onClick={handleToggleVisibility}>
                                    <ArrowDownIcon height={8} width={8} className={proyectosToMap.length > visibleItems ? styles.arrowDownIcon : styles.arrowUpIcon} />
                                    Mostrar más
                                    <ArrowDownIcon height={8} width={8} className={proyectosToMap.length > visibleItems ? styles.arrowDownIcon : styles.arrowUpIcon}/>
                                </div>
                            ) : (
                                proyectosToMap.length > 8 &&
                                <div className={styles.PerfilMain_content_seeMore} onClick={handleToggleVisibility}>
                                    <ArrowDownIcon height={8} width={8} className={styles.arrowUpIcon} />
                                    Ocultar
                                    <ArrowDownIcon height={8} width={8} className={styles.arrowUpIcon}/>
                                </div>
                            )
                        )}
                    </>
                ) : (
                    myPerson ? (
                        <div className={styles.emptyState} onClick={guard("quote_project", handleNewOpenProject)}>
                            <EmptyState title="No tienes proyectos publicados ¡Crea tu primer proyecto!" icon={<AddProyect width={50} height={50}/> } />
                        </div>
                    ) : (       
                        <EmptyState title="Este usuario no tiene proyectos publicados" icon={<Search width={50} height={50} />} />
                    )             
                )
            )}
        </motion.section>
    );
};

const mapStateToProps = (state) => {
    return {
        proyectos: state.profile.proyectos,
        proyectosLoading: state.profile.proyectosLoading,
    };
};

export default connect(mapStateToProps, {
    getProjects,
    closeMainModal,
})(MisProyectos);







